/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  --border-top: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --gap: var(--nve-ref-space-sm);
}

footer[internal-host] {
  padding: var(--padding);
  border-top: var(--border-top);
  color: var(--color);
  display: flex;
  place-items: flex-start;
  gap: var(--gap);

  ::slotted(nve-button) {
    flex-grow: 1;
  }
}
